<template>
  <div>
    <apexchart height="100%" :options="options" :series="series"></apexchart>
  </div>
</template>

<script>
import { chartTempoRessuprimento } from "./OptionsChart";

export default {
  props: ["data"],

  data: () => ({
    options: chartTempoRessuprimento,
    series: [],
  }),

  watch: {
    data() {
      if (
        this.data.mensal.referencias &&
        this.data.mensal.referencias.length > 0
      ) {
        this.render();
      }
    },
  },

  methods: {
    render: function () {
      this.options = {
        labels: this.data.mensal.referencias,
      };

      this.series = [
        {
          name: "Tempo Ressuprimento",
          color: "#04B431",
          data: this.data.mensal.tempo_ressuprimento,
        },
      ];
    },
  },
};
</script>
